import { render } from "./wTextArea.vue?vue&type=template&id=19d6e52a&ts=true"
import script from "./wTextArea.vue?vue&type=script&lang=ts"
export * from "./wTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__